import { AsyncPipe, KeyValue, KeyValuePipe, NgClass } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { ActivatedRoute, ActivationEnd, Event, Router, RouterLink } from '@angular/router';
import { CmsService, ProductService, UrlPipe } from '@spartacus/core';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { isEqual, uniqWith } from 'lodash';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BehaviorSubject, EMPTY, Observable, Subscription, combineLatest, concat, forkJoin, of } from 'rxjs';
import { distinctUntilChanged, filter, map, mergeMap, take, tap } from 'rxjs/operators';
import { DealerPrice } from 'src/app/model/dealer-price.model';
import { ShimanoProduct } from 'src/app/model/product.model';
import { ComponentService } from 'src/app/service/component.service';
import { DealerPriceService } from 'src/app/service/dealer-price/dealer-price.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { CustomProductService } from 'src/app/service/product/custom-product.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { Popover, PopoverProperties } from '../popover';
// tslint:disable-next-line: max-line-length
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteConfigService } from 'src/app/service/base-site/base-site-config.service';
import { TooltipTextComponent } from '../tooltip-text/tooltip-text.component';
import { ExplodedViewPopoverProductListingComponent } from './exploded-view-product-listing/exploded-view-popover-product-listing.component';
import { ExplodedViewProductListingComponent } from './exploded-view-product-listing/exploded-view-product-listing.component';

@Component({
  selector: 'app-shimano-exploded-view',
  templateUrl: './shimano-exploded-view.component.html',
  styleUrls: ['./shimano-exploded-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgbDropdownModule,
    MatIcon,
    NgClass,
    RouterLink,
    TooltipTextComponent,
    ExplodedViewProductListingComponent,
    MatIconButton,
    MatProgressSpinner,
    AsyncPipe,
    KeyValuePipe,
    UrlPipe,
  ],
})
export class ShimanoExplodedViewComponent implements OnInit, AfterViewInit, OnDestroy {
  products$: Observable<ShimanoProduct[]>;
  evBoms: string;
  dealerPrices: DealerPrice[];
  productCodesCount = 0;
  imageHeight: number;
  imageWidth: number;
  scaledImageHeight: number;
  scaledImageWidth = 1050;
  noImageHeight = 684;
  tabletExpandedImageWidth = 1114;
  mobileExpandedImageWidth = 985;
  imageContainerExpandedWidth: number;
  imageContainerExpandedHeight: number;
  initImageContainerWidth: number;
  initImageContainerHeight: number;
  scaledFactorStyle: number;
  unsortedExplodedView: any;
  productCodesWithBomItemNoMoq: any[];
  isExpandedImage = false;
  scaledCoordinateX$ = new BehaviorSubject(0);
  scaledCoordinateY$ = new BehaviorSubject(0);
  explodedViewId: string = this.route.snapshot.params.explodedViewId;
  explodedViewName: string = this.route.snapshot.params.name;
  activeExplodedViewId = this.explodedViewId;
  selectedExplodedViewName = this.explodedViewName;
  dropdownIsClosed = false;
  dropdownIsOpened = false;
  routerSubscription$: Subscription;
  storedInnerWidth = window.innerWidth;
  evPageSubscription$: Subscription;
  getLanguageSubscription$: Subscription;
  hasProductInProductEVList = false;
  activeToggler = false;
  storedLanguage = '';
  desktopClass = 'w-100';
  desktopClass2 = 'h-90';
  tabletClass = 'tablet-expanded';
  mobileClass = 'mobile-expanded';
  mobileClass2 = 'px-0';
  toggleBooleanForNotEqualWidth = true;
  indicatorThatItRotatedBackToFirstExpand = true;
  explodedViewDetails: any;
  basepriceBehaviorConfig$: Subscription;
  basepriceBehavior = false;
  isDiscontinuedEnabled: boolean;

  isTablet = false;
  cxTabletWidth = this.breakpointService.getSize(BREAKPOINT.lg);
  isMobile = false;
  cxMobileWidth = this.breakpointService.getSize(BREAKPOINT.sm);

  referrerProduct$: Observable<any> = this.productService.get(this.route.snapshot.params.code).pipe(
    filter(Boolean),
    map((data: any) => data),
    distinctUntilChanged(),
    tap((referrerProduct) => {
      this.componentService.explodedViewReferrerProduct$.next(referrerProduct);
      this.onLoadName(referrerProduct.explodedViewList);
    })
  );

  explodedView$: Observable<any>;
  businessType: string;
  selectedEVName: string;
  evUidList: any;

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    private customProductService: CustomProductService,
    private dealerPriceService: DealerPriceService,
    public componentService: ComponentService,
    private popover: Popover,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private breakpointService: BreakpointService,
    private currentBusinesstype: CurrentBusinessType,
    protected cms: CmsService,
    private languageService: ShimanoLanguageService,
    public deviceDetectorService: DeviceDetectorService,
    protected baseSiteConfigService: BaseSiteConfigService
  ) {}

  ngOnInit() {
    this.getExplodedViewDetails();
    this.isDiscountinuedStatusEnabled();

    this.routerSubscription$ = this.router.events.subscribe((event: Event) => {
      setTimeout(() => {
        if (event instanceof ActivationEnd && this.dropdownIsClosed) {
          this.activeExplodedViewId = event.snapshot.params.explodedViewId;
          this.getExplodedViewDetails();
          this.hasProductInProductEVList = false;
        }
        if (this.cdr && !(this.cdr as ViewRef).destroyed) {
          this.cdr.detectChanges();
        }
      }, 500);
    });
    this.businessType = this.currentBusinesstype.getBusinessType();

    this.getLanguageSubscription$ = this.languageService.getActive().subscribe((data) => {
      if ((this.businessType == 'fish' || 'bike') && data && data !== this.storedLanguage) {
        this.spinnerToggleSwitchingLanguages();
        this.getExplodedViewDetails();
        this.storedLanguage = data;
      }
    });
    this.basepriceBehaviorConfig$ = this.dealerPriceService.getBasepriceBehavior$().subscribe((hideBaseprice: any) => {
      if (hideBaseprice === 'true') {
        this.basepriceBehavior = true;
      } else {
        this.basepriceBehavior = false;
      }
      this.cdr.detectChanges();
    });
  }

  ngAfterViewInit() {
    this.evPageSubscription$ = this.componentService.selectedHotspotNumberFromImage$.subscribe((hotspot) => {
      if (hotspot && !this.componentService.expandedImageClicked$.getValue()) {
        if (this.hasProductInProductEVList) {
          this.hasProductInProductEVList = false;
        } else {
          this.hasProductInProductEVList = false;
          this.toggleSelectedProduct(0, false);
        }
      } else {
        this.hasProductInProductEVList = false;
      }
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });
  }

  evSelected(evUid: any) {
    if (evUid.uid === this.activeExplodedViewId) {
      this.selectedExplodedViewName = evUid.displayName;
    }
  }

  getExplodedViewSize() {
    let explodedView = this.explodedViewDetails;
    if (explodedView.boms) {
      this.isMobile = window.innerWidth < this.cxMobileWidth;
      this.isTablet = window.innerWidth < this.cxTabletWidth && !this.isMobile;
      this.imageWidth = explodedView.imageWidth;
      this.imageHeight = explodedView.imageHeight;
      this.scaledImageHeight =
        explodedView.image && explodedView.image.url
          ? (this.imageHeight *
              (this.isMobile ? window.innerWidth : this.isTablet ? window.innerWidth - 48 : this.scaledImageWidth)) /
            this.imageWidth
          : this.noImageHeight;
      this.componentService.initImageContainerHeight$.next(this.scaledImageHeight);
      this.componentService.initImageContainerWidth$.next(this.scaledImageWidth);
    }
  }

  getExplodedViewDetails() {
    this.explodedView$ = this.customProductService.getExplodedViewDetails(this.activeExplodedViewId).pipe(
      filter(Boolean),
      map((data: any) => data),
      distinctUntilChanged(),
      mergeMap((explodedView) => {
        if (explodedView.boms) {
          this.explodedViewDetails = explodedView;
          this.componentService.bomExplodedView$.next(explodedView.boms);
          // map product codes with hotspot number
          const mappedProductCodesWithBomItemNoMoq = [].concat(
            ...explodedView.boms
              .sort((a: { itemNo: any }, b: { itemNo: any }) => {
                if (this.businessType == 'fish') {
                  return a.itemNo.localeCompare(b.itemNo);
                } else {
                  return (a.itemNo as number) - (b.itemNo as number);
                }
              })
              .map((bom: any) =>
                bom.products.map((product: any) => ({
                  productCode: product.code,
                  bomItemNo: bom.itemNo ? bom.itemNo : -1,
                  minOrderQuantity: product.minOrderQuantity ? product.minOrderQuantity : 1,
                }))
              )
          );
          const products$: Observable<ShimanoProduct>[] = [].concat(
            ...explodedView.boms
              .sort((a: { itemNo: any }, b: { itemNo: any }) => {
                if (this.businessType == 'fish') {
                  return a.itemNo.localeCompare(b.itemNo);
                } else {
                  return (a.itemNo as number) - (b.itemNo as number);
                }
              })
              .map((bom: any) =>
                bom.products.map((product: any) => {
                  product.bomItemNo = bom.itemNo;
                  return of(product);
                })
              )
          ) as Observable<ShimanoProduct>[];

          this.productCodesWithBomItemNoMoq = uniqWith(
            mappedProductCodesWithBomItemNoMoq
              .filter((p) => {
                if (this.businessType !== 'fish') {
                  return p.bomItemNo > 0;
                } else {
                  return typeof p.bomItemNo !== 'undefined';
                }
              })
              .concat(mappedProductCodesWithBomItemNoMoq.filter((p) => p.bomItemNo === -1)),
            isEqual
          );
          this.componentService.defaultExplodedViewProductCodesWithBomItemNoMoq$.next(
            this.productCodesWithBomItemNoMoq
          );
          const productCodes = uniqWith(
            this.productCodesWithBomItemNoMoq.map((d) => d.productCode),
            isEqual
          );
          this.productCodesCount = productCodes.length;
          this.unsortedExplodedView = explodedView;

          // init scaled image dimensions
          this.isMobile = window.innerWidth < this.cxMobileWidth;
          this.isTablet = window.innerWidth < this.cxTabletWidth && !this.isMobile;
          this.imageWidth = explodedView.imageWidth;
          this.imageHeight = explodedView.imageHeight;
          this.scaledImageHeight =
            explodedView.image && explodedView.image.url
              ? (this.imageHeight *
                  (this.isMobile
                    ? window.innerWidth
                    : this.isTablet
                    ? window.innerWidth - 48
                    : this.scaledImageWidth)) /
                this.imageWidth
              : this.noImageHeight;
          this.componentService.initImageContainerHeight$.next(this.scaledImageHeight);
          this.componentService.initImageContainerWidth$.next(this.scaledImageWidth);
          this.componentService.shrinkImageClicked$.next(false);
          this.componentService.expandedImageClicked$.next(false);

          // get Product details and dealer prices
          // const products$: Observable<ShimanoProduct>[] = productCodes.map((code) =>
          //   this.productService.get(code)
          // ) as Observable<ShimanoProduct>[];

          return forkJoin([of(explodedView), of(products$), this.getDealerPrices(productCodes)]);
        } else {
          return EMPTY;
        }
      }),
      map(([explodedView, products$, dealerPrices]) => {
        const products = combineLatest(products$.map((product$) => concat(product$)));
        if (dealerPrices) {
          this.dealerPrices = dealerPrices.dealerPrices;
          this.componentService.defaultExplodedViewDealerPrices$.next(this.dealerPrices);
        }
        this.products$ = products;
        this.componentService.defaultExplodedViewProducts$.next(products);
        this.evBoms = explodedView.boms;
        this.componentService.bomExplodedView$.next(explodedView.boms);
        return { ...explodedView, products };
      })
    );
  }

  get uniqueBomHotspots$(): Observable<any> {
    const sortedBomHotspots = this.unsortedExplodedView.boms.map(
      (bom: any) =>
        bom.hotspots &&
        bom.hotspots
          .sort((a: { coordinateY: number }, b: { coordinateY: number }) => a.coordinateY - b.coordinateY)
          .map((hotspot: any) => ({
            itemNo: bom.itemNo,
            hotspot: hotspot ? hotspot : null,
          }))
    );
    return of(uniqWith(sortedBomHotspots, isEqual));
  }

  onOpenChangeEvId(event: any) {
    this.dropdownIsClosed = !event;
    this.dropdownIsOpened = event;
  }

  isDisabled(hotspot: number): Observable<boolean> {
    const codes = this.productCodesWithBomItemNoMoq.filter((p) => p.bomItemNo === hotspot).map((q) => q.productCode);
    return combineLatest(...codes.map((code) => this.isOutOfStock(code))).pipe(
      map((results) => results.every((result) => result))
    );
  }

  isOutOfStock(code: string): Observable<boolean> {
    return this.products$.pipe(
      map(
        (products) =>
          products
            .filter((product) => product && product.code === code)
            .map((res: any) => {
              return res.stock && res.stock.stockLevelStatus === 'outOfStock'
                ? true
                : res.stock && res.stock.stockLevelStatus === 'backorder'
                ? false
                : !res.inStockFlag;
            })[0]
      )
    );
  }

  isNonSellable(code: string): Observable<boolean> {
    return this.products$.pipe(
      map(
        (products) =>
          products
            .filter((product) => product && product.code === code)
            .map((res: any) => {
              return (
                (res.stock && res.stock.stockLevelStatus === 'outOfStock' ? true : !res.inStockFlag) &&
                res.hasOwnProperty('replacedBy')
              );
            })[0]
      )
    );
  }

  toggleSelectedProduct(hotspotNumber: number, isSelected: boolean) {
    if (isSelected && this.hasProductInProductEVList) {
      this.componentService.selectedHotspotNumber$.next(hotspotNumber);
      this.componentService.selectedHotspotNumberFromImage$.next(hotspotNumber);
    } else {
      this.componentService.selectedHotspotNumber$.next(0);
      this.componentService.selectedHotspotNumberFromImage$.next(0);
    }
  }

  isActive(hotspotNumber: number): boolean {
    if (
      window.innerWidth !== this.storedInnerWidth &&
      this.componentService.expandedImageClicked$.getValue() === false
    ) {
      this.storedInnerWidth = window.innerWidth;
      this.getExplodedViewDetails();
    }
    return hotspotNumber ? this.componentService.selectedHotspotNumber$.getValue() === hotspotNumber : false;
  }

  resizingOfExpandedImage() {
    const loadingContainer = document.getElementsByClassName('desktopImage')[0] as HTMLElement;
    const bodyContent = document.getElementsByClassName('body-content')[0] as HTMLElement;
    let widthIsMobile = window.innerWidth < this.cxMobileWidth;
    let widthIsTablet = window.innerWidth < this.cxTabletWidth && window.innerWidth > this.cxMobileWidth;
    let widthIsDesktop = window.innerWidth >= this.cxTabletWidth;
    // Since at first click of expand icon, the storedInnerWidth and innerwidth are equal
    // If the device gets rotated and the device width exceeds to current breakpoint range or came back to previous breakpoint range
    // therefore the Class names will be changed based on its proper breakpoint range
    // Example (with vice versa):
    // Current device is Tablet Portrait -> Gets Rotated -> Width exceeds to Desktop range -> Tablet class will replace by Desktop class
    // Current device is Tablet Landscape (Desktop range) -> Gets Rotated -> Width back to Tablet range -> Desktop class will replace by Tablet class
    if (
      this.componentService.expandedImageClicked$.getValue() &&
      window.innerWidth !== this.storedInnerWidth &&
      this.toggleBooleanForNotEqualWidth
    ) {
      if (widthIsDesktop && this.deviceDetectorService.isTablet()) {
        this.addingAndRemovingTabletClasses(loadingContainer, bodyContent, true);
      } else if (widthIsTablet && this.deviceDetectorService.isTablet()) {
        this.addingAndRemovingTabletClasses(loadingContainer, bodyContent, false);
      }
      if (widthIsTablet && this.deviceDetectorService.isMobile()) {
        this.addingAndRemovingMobileClasses(loadingContainer, bodyContent, true);
      } else if (widthIsMobile && this.deviceDetectorService.isMobile()) {
        this.addingAndRemovingMobileClasses(loadingContainer, bodyContent, false);
      }
      this.getExplodedViewSize();
      this.toggleExpandImagePosition();
      this.toggleBooleanForNotEqualWidth = false;
      this.indicatorThatItRotatedBackToFirstExpand = true;
    } else if (
      this.componentService.expandedImageClicked$.getValue() &&
      window.innerWidth === this.storedInnerWidth &&
      this.toggleBooleanForNotEqualWidth === false
    ) {
      if (this.deviceDetectorService.isTablet() && this.indicatorThatItRotatedBackToFirstExpand) {
        if (widthIsTablet) {
          this.addingAndRemovingTabletClasses(loadingContainer, bodyContent, false);
        } else if (widthIsDesktop) {
          this.addingAndRemovingTabletClasses(loadingContainer, bodyContent, true);
        }
      }
      if (this.deviceDetectorService.isMobile() && this.indicatorThatItRotatedBackToFirstExpand) {
        if (widthIsMobile) {
          this.addingAndRemovingMobileClasses(loadingContainer, bodyContent, false);
        } else if (widthIsTablet) {
          this.addingAndRemovingMobileClasses(loadingContainer, bodyContent, true);
        }
      }
      this.getExplodedViewSize();
      this.toggleExpandImagePosition();
      this.indicatorThatItRotatedBackToFirstExpand = false;
      this.toggleBooleanForNotEqualWidth = true;
    }
  }

  addingAndRemovingTabletClasses(imageClass: any, bodyContentClass: any, greaterThanTabletRange: boolean) {
    if (greaterThanTabletRange) {
      imageClass.classList.remove(this.tabletClass);
      bodyContentClass.classList.remove(this.tabletClass);
      bodyContentClass.classList.add(this.desktopClass);
      bodyContentClass.classList.add(this.desktopClass2);
    }
    if (greaterThanTabletRange === false) {
      imageClass.classList.add(this.tabletClass);
      bodyContentClass.classList.add(this.tabletClass);
      bodyContentClass.classList.remove(this.desktopClass);
      bodyContentClass.classList.remove(this.desktopClass2);
    }
  }

  addingAndRemovingMobileClasses(imageClass: any, bodyContentClass: any, greaterThanMobileRange: boolean) {
    if (greaterThanMobileRange) {
      imageClass.classList.remove(this.mobileClass);
      bodyContentClass.classList.remove(this.mobileClass);
      bodyContentClass.classList.remove(this.mobileClass2);
      imageClass.classList.add(this.tabletClass);
      bodyContentClass.classList.add(this.tabletClass);
    }
    if (greaterThanMobileRange === false) {
      imageClass.classList.add(this.mobileClass);
      bodyContentClass.classList.add(this.mobileClass);
      bodyContentClass.classList.add(this.mobileClass2);
      imageClass.classList.remove(this.tabletClass);
      bodyContentClass.classList.remove(this.tabletClass);
    }
  }

  @HostListener('window:resize')
  getScaledCoordinateX(
    actualCoordinateX?: number,
    leftContent?: HTMLElement,
    bodyContent?: HTMLElement,
    imageContainer?: HTMLElement
  ): number {
    let imageContainerWidth: number;
    if (
      !this.componentService.shrinkImageClicked$.getValue() &&
      !this.componentService.expandedImageClicked$.getValue()
    ) {
      if (imageContainer) {
        imageContainerWidth = imageContainer.offsetWidth;
      } else {
        imageContainerWidth = this.scaledImageWidth;
      }
      this.componentService.initImageContainerWidth$.next(imageContainerWidth);
    } else if (this.componentService.shrinkImageClicked$.getValue()) {
      imageContainerWidth = this.componentService.initImageContainerWidth$.getValue();
    } else {
      if (leftContent && bodyContent) {
        imageContainerWidth = this.isMobile
          ? this.mobileExpandedImageWidth
          : this.isTablet
          ? this.tabletExpandedImageWidth
          : leftContent.offsetWidth + bodyContent.offsetWidth;
        if (!this.isTablet && !this.isMobile) {
          this.componentService.initImageContainerWidth$.next(imageContainerWidth * 0.75);
        }
      }
    }
    const scaledFactorX = imageContainerWidth / this.imageWidth;
    return scaledFactorX * actualCoordinateX;
  }

  @HostListener('window:resize')
  getScaledCoordinateY(
    actualCoordinateY?: number,
    leftContent?: HTMLElement,
    bodyContent?: HTMLElement,
    imageContainer?: HTMLElement
  ): number {
    let imageContainerHeight: number;
    if (
      !this.componentService.shrinkImageClicked$.getValue() &&
      !this.componentService.expandedImageClicked$.getValue()
    ) {
      if (imageContainer) {
        if (imageContainer.offsetHeight) {
          imageContainerHeight = imageContainer.offsetHeight;
        } else {
          imageContainerHeight = this.imageHeight * (imageContainer.clientWidth / this.imageWidth);
        }
      } else {
        imageContainerHeight = this.scaledImageHeight;
      }
      this.componentService.initImageContainerHeight$.next(imageContainerHeight);
    } else if (this.componentService.shrinkImageClicked$.getValue()) {
      imageContainerHeight = this.componentService.initImageContainerHeight$.getValue();
    } else {
      if (leftContent && bodyContent) {
        imageContainerHeight =
          this.imageHeight *
          ((this.isMobile
            ? this.mobileExpandedImageWidth
            : this.isTablet
            ? this.tabletExpandedImageWidth
            : leftContent.offsetWidth + bodyContent.offsetWidth) /
            this.imageWidth);
        if (!this.isTablet && !this.isMobile) {
          this.componentService.initImageContainerHeight$.next(imageContainerHeight * 0.75);
        }
      }
    }
    const scaledFactorY = imageContainerHeight / this.imageHeight;
    this.scaledFactorStyle = scaledFactorY;
    return scaledFactorY * actualCoordinateY;
  }

  getDealerPrices(productCodes: string[]): Observable<any> {
    return this.dealerPriceService.getDealerPricesByProductCodes(productCodes);
  }

  toggleExpandImage() {
    this.isExpandedImage = !this.componentService.expandedImageClicked$.getValue();
    this.componentService.selectedHotspotNumber$.next(0);
    if (this.isExpandedImage) {
      this.componentService.expandedImageClicked$.next(true);
      this.componentService.shrinkImageClicked$.next(false);
    } else {
      this.componentService.expandedImageClicked$.next(false);
      this.componentService.shrinkImageClicked$.next(true);
      this.toggleBooleanForNotEqualWidth = true;
      this.getExplodedViewDetails();
    }
  }

  toggleExpandImagePosition(): number {
    let imageContainerElem = document.getElementById('image-container');
    let imageContainerClientWidth: number;
    let imageContainerScrollWidth: number;
    if (imageContainerElem && this.componentService.expandedImageClicked$.getValue()) {
      imageContainerClientWidth = imageContainerElem.clientWidth;
      imageContainerScrollWidth = imageContainerElem.scrollWidth;
    }
    if (
      imageContainerScrollWidth > imageContainerClientWidth &&
      this.componentService.expandedImageClicked$.getValue() &&
      window.innerWidth < this.cxTabletWidth &&
      window.innerWidth > this.cxMobileWidth
    ) {
      let positionOfExpandedIcon = 1114 - imageContainerClientWidth;
      return -positionOfExpandedIcon;
    }
  }

  getProductsCountInPopover(hotspotNumber: number, forPopover = false): number {
    const productsCountInPopover = this.productCodesWithBomItemNoMoq.filter(
      (p) => p.bomItemNo === hotspotNumber
    ).length;
    if (forPopover) {
      this.componentService.productsCountInPopover$.next(productsCountInPopover);
    }
    return productsCountInPopover;
  }

  showPopover(prop: PopoverProperties, isActive: boolean) {
    if (this.componentService.expandedImageClicked$.getValue() && isActive) {
      prop.component = ExplodedViewPopoverProductListingComponent;
      prop.position = { top: prop.event.clientY, left: this.isMobile ? window.innerWidth * 0.5 : prop.event.clientX };
      prop.shadow = true;
      prop.autoPlacement = true;
      prop.alignToCenter = true;
      prop.noArrow = true;
      prop.width = this.deviceDetectorService.isMobile() ? '320px' : '335px';
      prop.maxWidth = this.deviceDetectorService.isMobile() ? '320px' : '335px';
      if (this.getProductsCountInPopover(this.componentService.selectedHotspotNumber$.getValue(), true) > 1) {
        prop.height = this.deviceDetectorService.isMobile() ? '228px' : '428px';
        prop.popoverClass = 'overflow-auto';
      } else {
        prop.height = this.deviceDetectorService.isMobile() ? '192px' : '198px';
      }
      prop.padding = '0px';
      prop.offset = 12;
      this.popover.load(prop);
    }
  }

  scrollHotspotIntoView(event: any) {
    const elId = event.srcElement.id ? event.srcElement.id : event.srcElement.parentElement.id;
    const selectedHotspot = document.getElementById(elId);
    selectedHotspot.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    });
  }

  valueAscOrder(a: KeyValue<number, string>, b: KeyValue<number, string>): number {
    return a.value.localeCompare(b.value);
  }

  onLoadName(refererProductData: any) {
    this.selectedEVName = refererProductData.filter(
      (uidList: any) => uidList.uid === this.explodedViewId
    )[0].displayName;
    this.selectedExplodedViewName = this.selectedEVName;
    this.evUidList = refererProductData.map((evUid: any) => evUid.uid);
  }
  onNameSelection(names: any) {
    this.selectedExplodedViewName = names;
  }

  hasProductInEVList(hasProduct: any) {
    if (hasProduct) {
      this.activeToggler = true;
      this.hasProductInProductEVList = true;
    } else {
      this.activeToggler = false;
      this.hasProductInProductEVList = false;
    }
  }

  spinnerToggleSwitchingLanguages() {
    const loadingContainer = document.getElementsByClassName('top-content')[0] as HTMLElement;
    if (loadingContainer && loadingContainer.classList.contains('evhasloaded')) {
      loadingContainer.classList.remove('evhasloaded');
    }
  }

  posWhileLoading(evDetail: any) {
    const loadingContainer = document.getElementsByClassName('top-content')[0] as HTMLElement;
    evDetail ? loadingContainer.classList.add('evhasloaded') : loadingContainer.classList.remove('evhasloaded');
  }

  isDiscountinuedStatusEnabled(): void {
    this.getDiscountedStatusConfig$()
      .pipe(take(1))
      .subscribe((enabled) => {
        this.componentService.setDiscontinuedEnabled(enabled);
        this.isDiscontinuedEnabled = enabled ?? false;
      });
  }

  getDiscountedStatusConfig$(): Observable<boolean> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.discontinued.status.enabled'])
      .pipe(
        map(
          (configs) =>
            configs &&
            configs
              .filter((config: any) => config.key === 'shimano.discontinued.status.enabled')
              .map((res: any) => res.value)[0]
        )
      );
  }

  ngOnDestroy() {
    if (this.routerSubscription$) {
      this.routerSubscription$.unsubscribe();
    }
    if (this.evPageSubscription$) {
      this.evPageSubscription$.unsubscribe();
    }
    if (this.getLanguageSubscription$) {
      this.getLanguageSubscription$.unsubscribe();
    }
    if (this.basepriceBehaviorConfig$) {
      this.basepriceBehaviorConfig$.unsubscribe();
    }
  }
}
